module.exports = __webpack_public_path__ + "images/mini_small5d95c652330670eaf7c28e30284f0fbd.png";